<template>
  <div class="coupon-selector">
    <md-popup
      v-model="dialogVisible"
      position="bottom"
      :mask-closable="false"
    >
      <div class="selector-popup">
        <div class="icon-close" @click="hideDialog">
          <img src="@/assets/image/icons/icon-close.png">
        </div>
        <div class="title">
          {{ $t('title') }}
        </div>
        <div v-if="couponList.length">
          <div class="coupon-list">
            <div v-for="(option, index) in orderedCouponList" :key="index">
              <md-check
                :name="option.id"
                v-model="selectedCouponId"
                :disabled="option.disabled"
                iconDisabled="check"
              >
                <div class="coupon-item">
                  <div class="coupon-value">
                    <div v-if="option.percentage" class="rate">{{ option.percentage }}%</div>
                    <div v-else class="amount">
                      <span class="unit">Rp</span>
                      <span class="number">{{ option.rebate | formatMoney(true, true)}}</span>
                    </div>
                  </div>
                  <div class="coupon-detail">
                    <div class="name">{{ option.displayName[locale] }}</div>
                    <div v-if="option.limitInvestMinAmount" class="desc">
                      {{ $t('investLimit') }} {{ option.limitInvestMinAmount | formatMoney }}
                    </div>
                    <div v-else class="desc">
                      {{ $t('noLimit') }}
                    </div>
                  </div>
                </div>
              </md-check>
            </div>
          </div>
          <md-button type="primary" round @click="confirm">
            {{ $t('confirm') }}
          </md-button>
        </div>
        <div v-else class="no-data">
          {{ $t('noCoupon')}}
        </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { Button, Popup, Check } from 'mand-mobile'
import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        title: 'Choose coupon',
        investLimit: 'Invest at least ',
        noCoupon: 'No Coupon',
        noLimit: 'No minimum investment amount',
        confirm: 'Confirm',
      },
      id: {
        title: 'Pilih Kupon',
        investLimit: 'Minimum pendanaan ',
        noCoupon: 'Tidak Ada Kupon',
        noLimit: 'Tidak ada batas minimum pendanaan',
        confirm: 'Konfirmasi',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Check.name]: Check,
  },
  mixins: [dialogMixins],
  props: {
    couponList: {
      type: Array,
      default: null,
    },
    inputAmount: {
      type: Number,
      default: 0,
    },
    selectedId: {
      type: String,
      default: '',
    },
    isTrial: {
      tpye: Boolean,
      default: false,
    },
  },
  data() {
    return {
      amount: this.inputAmount,
      selectedCoupon: null,
      selectedCouponId: this.selectedId,
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    orderedCouponList() {
      if (!Array.isArray(this.couponList)) {
        return []
      }
      this.couponList.forEach(i => {
        i.value = i.id
        i.disabled = this.isTrial || this.inputAmount < i.limitInvestMinAmount
      })
      let list = this.couponList
      let validList = list.filter(i => this.inputAmount >= i.limitInvestMinAmount)
      let inValidList = list.filter(i => this.inputAmount < i.limitInvestMinAmount)
      return validList.concat(inValidList)
    },
  },
  methods: {
    couponSelect(option, index) {
      this.$emit('onSelectCoupon', option)
      this.hideDialog()
    },
    confirm() {
      this.$emit('onSelectCoupon', this.orderedCouponList.find(i => i.id === this.selectedCouponId))
      this.hideDialog()
    },
  },
  watch: {
    inputAmount: function(newVal, oldVal) {
      this.amount = newVal
    },
    selectedId: function(newVal, oldVal) {
      this.selectedCouponId = newVal
    },
  },
}
</script>

<style scoped lang="stylus">
.coupon-selector /deep/ {
  .md-popup-box {
    border-radius: 16px 16px 0 0;
    max-height: 90%;
  }
}

.selector-popup /deep/ {
  position: relative;
  width: 100%;
  background-color: #fafafa;
  padding: 20px 20px 40px;
}

.icon-close {
  position: absolute;
  top: 16px;
  right: 16px;
  font-size: 16px;
  color: #ccc;
  img {
    width: 20px;
    height: 20px;
  }
}

.title {
  text-align: center;
  font-size: 16px;
  color: #555;
  margin-bottom: 26px;
}

.coupon-list /deep/ {
  height: 360px;
  overflow-y: scroll;
  margin-bottom: 16px;
  .md-check {
    flex-direction: row-reverse;
    background-image: url('../../assets/image/user/ticket/bg-coupon-available.png');
    background-size: 100% 100%;
    margin: 0;
    &.is-disabled {
      opacity: .4;
    }
    .md-check-icon {
      width: 34px;
    }
    .md-check-label {
      width: 100%;
      margin-left: 0;
    }
    .coupon-item {
      width: 100%;
      padding: 16px 6px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      .coupon-value {
        width: 46%;
        color: color-primary;
        text-align: center;
        .rate {
          font-family: 'Reducto';
          font-size: 36px;
          line-height: 40px;
        }
        .amount {
          .unit {
            font-family: 'Reducto';
            font-size: 14px;
            margin-right: 2px;
          }
          .number {
            font-family: 'Reducto';
            font-size: 24px;
          }
        }
      }
      .coupon-detail {
        height: 100%;
        padding: 20px 36px 20px 20px;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .name {
          color: #3F424E;
          font-size: 14px;
          margin-bottom: 12px;
        }
        .desc {
          color: #888;
          font-size: 10px;
          line-height: 14px;
        }
      }
    }
  }
}

</style>
